<template>
  <div class="card">
    <div class="card-header">
      <img v-if="icon" :src="resolvedIcon" alt="Icon" class="card-icon" />
      <h3>{{ title }}</h3>
    </div>
    <div class="card-body">
      <p :class="valueClass">{{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogicCardEChart",
  props: {
    title: String,
    value: [String, Number],
    icon: String,
    type: String
  },
  computed: {
    resolvedIcon() {
      try {
        return require(`${this.icon}`);
      } catch {
        return this.icon;
      }
    },
    valueClass() {
      console.log(this.value);
      const isZeroValue = value =>
        value == "R$ 0,00" ||
        value == "R$0,00" ||
        value == "R$ 0,00" ||
        value == 0;

      if (this.type === "result") {
        const valueStr = String(this.value);
        return {
          "text-red": valueStr.includes("-"),
          "text-green": !valueStr.includes("-")
        };
      } else if (this.type === "loss") {
        return { "text-red": !isZeroValue(this.value) };
      } else if (this.type === "gain") {
        return { "text-green": !isZeroValue(this.value) };
      } else {
        return {};
      }
    }
  }
};
</script>

<style scoped>
.card {
  width: 100%;
  height: 100%;
  max-height: 110px;
  padding: 20px;
  background-color: #1e1e2f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.212);
  border-radius: 14px;
  margin-bottom: 0;
  transition: transform 0.3s, box-shadow 0.3s;
  overflow: hidden;
  border-color: #ffffff;
  border: 1px solid;
}

.card-header {
  display: flex;
  align-items: center;
  margin-top: -19px;
}

.card-header h3 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  flex: 1;
  color: gray;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.3;
}

.card-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
  margin-left: -15px;
}

.card-body {
  font-size: 23px;
  color: #ffffff;
  line-height: 1.5;
  text-align: right;
}

.text-red {
  color: #ec5353;
}

.text-green {
  color: rgb(52, 160, 25);
}

@media (max-width: 768px) {
  .card {
    padding: 15px;
  }

  .card-header h3 {
    font-size: 13px;
  }

  .card-body {
    font-size: 20px;
  }

  .card-icon {
    width: 32px;
    height: 32px;
  }
}
</style>
